export default __webpack_public_path__ + "491ff191e715bedea36f7655ff7485ca.svg";